<template>
	<div>
		<!-- <a href="#" class="button secondary" data-reveal-id="preview">Preview</a> -->

<!-- <div id="preview" class="reveal-modal" data-reveal aria-labelledby="modalTitle" aria-hidden="true" role="dialog"> -->
	<div>
		<!-- <img :src="logoUrl" style="max-width:90%; max-height:250px; display:block; margin: 0 auto; " v-if="logoUrl.length > 0"/> -->
	  	
		<div class="row mbl text-left">
			<div class="columns medium-12">
				<span class="label" :style="{backgroundColor: secondaryColour, color: '#fff'}">TERM</span>
				<h4 class="mbn" :style="{color: primaryColour}"><strong>My Spring Term</strong></h4>
			</div>
		</div>

			<div class="row">

				<div class="columns  large-12">
					<table class="full-width">
						<thead>
							<tr>
								<th>Day</th>
								<th class="show-for-medium-up">Time</th>
								<th class="show-for-medium-up">Venue</th>
								<th>Class</th>
								<th></th>
							</tr>
						</thead>
						

						<tbody class="break">

							<tr>
								<td><strong>Mon</strong></td>
								
								<td class="">

									<div class="show-for-medium-up">
										4:00PM - 5:30PM
									</div>
									<div class="show-for-small-only">
										<span class="smaller">4:00PM - 5:30PM</span><br />
										<strong>Football Friendlies</strong><br />
										<span class="smaller">


											<a href="#">The School Hall</a>

											
												
										</span>						
									</div>

								</td>
								<td class="show-for-medium-up">
										<a href="#"> The Football Field</a>
									</td>
								<td class="show-for-medium-up">Football Friendlies
										<br>
											
											<a href="#">
												<span class="label left mbs trial-label" :style="{backgroundColor: secondaryColour, color: '#fff'}">OFFERS TRIAL</span>
												
											</a>
								</td>


								
								<td class="" style="width: 20%">
										<a class="button radius small expand" :style="{backgroundColor: primaryColour}" href="#">
											<i class="fa fa-info-circle"></i> Info and booking
										</a>
								</td>
							</tr>


							<tr>
								<td><strong>Tue</strong></td>
								
								<td class="">

									<div class="show-for-medium-up">
										4:00PM - 5:30PM
									</div>
									<div class="show-for-small-only">
										<span class="smaller">4:00PM - 5:30PM</span><br />
										<strong>Football Friendlies</strong><br />
										<span class="smaller">


											<a href="#">The School Hall</a>

											
												
										</span>

										<br>
			
											<a href="#">
												<span class="label left mbs trial-label" :style="{backgroundColor: secondaryColour, color: '#fff'}">TRIAL</span>
											</a>							
									</div>

								</td>
								<td class="show-for-medium-up">
										<a href="#"> The Football Field</a>
									</td>
								<td class="show-for-medium-up">Football Friendlies
										<br>
											
											<a href="#">
												<span class="label left mbs trial-label" :style="{backgroundColor: secondaryColour, color: '#fff'}">OFFERS TRIAL</span>
												
											</a>
								</td>


								
								<td class="" style="width: 20%">
										<a class="button radius small expand" :style="{backgroundColor: primaryColour}" href="#">
											<i class="fa fa-info-circle"></i> Info and booking
										</a>
								</td>
							</tr>



						</tbody>


					</table>
				</div>

			</div>




			

		  <!-- <a class="close-reveal-modal" aria-label="Close">&#215;</a> -->
		</div>
	</div>



</template>


<script>
'use strict';
import { mapGetters } from 'vuex';


export default {
	name: 'ThemePreview',
	data() {
		return {

		};
	},

	methods: {


	},

	computed: {
		...mapGetters([
			'logoUrl',
			'themes'
		]),

		selectedTheme: {
			get() {
				return this.$store.getters.selectedTheme
			},
			async set(value) {
				this.loadingTheme = true;
				await this.$store.dispatch('UPDATE_THEME', value);
				this.loadingTheme = false;
			}
		},

		colours() {

			if(this.$store.getters.themes.length > 0 && this.selectedTheme) {			
				const theme =  this.$store.getters.themes.find( theme => {
					return this.selectedTheme == theme.skinKey;
				});
				
				if(theme) {
					return theme.colours;
				} else {
					return ['555', '9d9d9d', 'F5F5F5'];
				}

			} else {
				return ['555', '9d9d9d', 'F5F5F5'];
			}
		},
		primaryColour() {
			return `#${this.colours[0]}`;
		},
		secondaryColour() {
			return `#${this.colours[1]}`;
		},
		panelColour() {
			return `#${this.colours[2]}`;
		}



	},

	components: {},

	beforeMount() {
		// this.setting = this.$root.$el.dataset.settingName;
		// this.label = this.$root.$el.dataset.settingLabel;
	},

	mounted() {},
	created() {

	}
};
</script>



<style lang="scss" scoped>

</style>
